import {anomaliesConstants} from "./anomalies.constants.js";
import {anomaliesService} from "./anomalies.service.js";
import {toastHelper} from "../../utils/toast-helper";
import Constants from "../../utils/constants";

export const anomaliesActions = {
    fetchAnomalies,
    fetchAnomaliesCount,
    ignorerAnomalie,
    corrigerIntervention,
    appliquerAuPatrimoine,
    acquitterLavageImpossible,
    modifierProbleme,
    clearAnomalies,
};

function fetchAnomalies() {
    return dispatch => {
        dispatch(request());

        anomaliesService.fetchAnomalies()
            .then(
                anomalies => {
                    dispatch(success(anomalies));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };

    function request() {
        return {type: anomaliesConstants.ANOMALIES_FETCH_REQUEST}
    }

    function success(anomalies) {
        return {type: anomaliesConstants.ANOMALIES_FETCH_SUCCESS, anomalies}
    }

    function failure(error) {
        return {type: anomaliesConstants.ANOMALIES_FETCH_FAILURE, error}
    }
}

/** Silencieux (polling badge) : pas de loading global, pas de toast */
function fetchAnomaliesCount() {
    return dispatch => {
        anomaliesService.fetchAnomaliesCount()
            .then(
                count => {
                    dispatch({type: anomaliesConstants.ANOMALIES_COUNT_SUCCESS, count});
                },
                () => {
                    // silencieux : le badge garde sa dernière valeur
                }
            );
    };
}

/** L'écart est justifié, on ne touche à rien */
function ignorerAnomalie(anomalie) {
    return dispatch => {
        dispatch(request(anomalie.id));

        anomaliesService.resolveAnomalie(anomalie.id, Constants.ANOMALIE_RESOLUTION_IGNOREE)
            .then(
                () => {
                    dispatch(success(anomalie.id, "L'écart a été ignoré."));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
}

/** Erreur de saisie terrain : on corrige l'intervention (le back auto-résout) */
function corrigerIntervention(anomalie, values) {
    return dispatch => {
        dispatch(request(anomalie.id));

        anomaliesService.updateIntervention(anomalie.intervention.id, values)
            .then(
                () => {
                    dispatch(success(anomalie.id, "L'intervention a été corrigée."));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
}

/** Le terrain a raison : on aligne la quantité du conteneur, puis on résout */
function appliquerAuPatrimoine(anomalie) {
    return dispatch => {
        dispatch(request(anomalie.id));

        anomaliesService.updateConteneur(anomalie.intervention.conteneur.id, {quantite: anomalie.nombreLaves})
            .then(() => anomaliesService.resolveAnomalie(anomalie.id, Constants.ANOMALIE_RESOLUTION_PATRIMOINE_MAJ))
            .then(
                () => {
                    dispatch(success(anomalie.id, "Le patrimoine a été mis à jour."));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
}

/** Lavage impossible : saisie et problème cohérents, on acquitte (RAS) */
function acquitterLavageImpossible(anomalie) {
    return dispatch => {
        dispatch(request(anomalie.id));

        anomaliesService.resolveAnomalie(anomalie.id, Constants.ANOMALIE_RESOLUTION_VALIDEE)
            .then(
                () => {
                    dispatch(success(anomalie.id, "Le lavage impossible a été validé."));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
}

/**
 * Lavage impossible : le problème rattaché était erroné, on le corrige puis on
 * acquitte dans la foulée (même pattern que appliquerAuPatrimoine : 2 appels).
 * @param problemeIris IRIs des problèmes sélectionnés (["/api/problems/3", ...])
 */
function modifierProbleme(anomalie, problemeIris) {
    return dispatch => {
        dispatch(request(anomalie.id));

        anomaliesService.updateIntervention(anomalie.intervention.id, {problemes: problemeIris})
            .then(() => anomaliesService.resolveAnomalie(anomalie.id, Constants.ANOMALIE_RESOLUTION_VALIDEE))
            .then(
                () => {
                    dispatch(success(anomalie.id, "Le problème a été corrigé et la ligne validée."));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
}

function clearAnomalies() {
    return dispatch => {
        dispatch({type: anomaliesConstants.ANOMALIES_CLEAR});
    };
}

function request(id) {
    return {type: anomaliesConstants.ANOMALIES_RESOLVE_REQUEST, id}
}

function success(id, message) {
    toastHelper.displaySuccess(message)
    return {type: anomaliesConstants.ANOMALIES_RESOLVE_SUCCESS, id}
}

function failure(error) {
    toastHelper.handleError(error, "Oops, une erreur est survenue.")
    return {type: anomaliesConstants.ANOMALIES_RESOLVE_FAILURE, error}
}
